var _g, _g2, _rect, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 304,
    viewBox: "0 0 700 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 52.4615,
    width: 383.59,
    height: 237.128,
    rx: 13.9487,
    fill: "#828282"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.974,
    y: 42,
    width: 383.59,
    height: 237.128,
    rx: 13.9487,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156.744,
    y: 50.0205,
    width: 382.892,
    height: 236.431,
    rx: 13.6,
    fill: "#1F1F1F",
    stroke: "url(#paint0_linear_1_818)",
    strokeWidth: 0.697436
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 451.134,
    cy: 160.14,
    r: 18.8308,
    transform: "rotate(-1.31552 451.134 160.14)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.841,
    cy: 159.596,
    r: 18.8308,
    transform: "rotate(-1.31552 474.841 159.596)",
    fill: "#5D5D5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.141 152.111C272.853 152.111 274.216 152.669 275.232 153.783C276.267 154.898 276.784 156.391 276.784 158.262V167.458H272.932V158.531C272.932 157.635 272.714 156.938 272.276 156.441C271.838 155.943 271.221 155.694 270.424 155.694C269.549 155.694 268.862 155.983 268.364 156.56C267.886 157.137 267.648 157.973 267.648 159.068V167.458H263.796V158.531C263.796 157.635 263.577 156.938 263.139 156.441C262.701 155.943 262.084 155.694 261.288 155.694C260.432 155.694 259.745 155.983 259.228 156.56C258.73 157.137 258.481 157.973 258.481 159.068V167.458H254.629V152.529H258.481V154.112C259.377 152.778 260.76 152.111 262.631 152.111C264.463 152.111 265.816 152.828 266.692 154.261C267.687 152.828 269.17 152.111 271.141 152.111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.273 156.769C244.273 157.167 244.532 157.496 245.05 157.755C245.587 157.993 246.234 158.212 246.991 158.411C247.747 158.591 248.503 158.829 249.26 159.128C250.016 159.407 250.653 159.884 251.171 160.561C251.708 161.238 251.977 162.084 251.977 163.099C251.977 164.632 251.4 165.816 250.245 166.652C249.11 167.468 247.687 167.876 245.975 167.876C242.91 167.876 240.82 166.692 239.705 164.323L243.049 162.442C243.487 163.736 244.463 164.383 245.975 164.383C247.349 164.383 248.036 163.955 248.036 163.099C248.036 162.701 247.767 162.382 247.229 162.144C246.712 161.885 246.075 161.656 245.318 161.457C244.562 161.258 243.806 161.009 243.049 160.71C242.293 160.412 241.646 159.944 241.108 159.307C240.591 158.65 240.332 157.834 240.332 156.859C240.332 155.386 240.87 154.231 241.945 153.395C243.039 152.539 244.393 152.111 246.005 152.111C247.219 152.111 248.324 152.39 249.319 152.947C250.315 153.485 251.101 154.261 251.678 155.276L248.394 157.068C247.916 156.053 247.12 155.545 246.005 155.545C245.508 155.545 245.09 155.654 244.751 155.873C244.433 156.092 244.273 156.391 244.273 156.769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.003 165.607C234.47 167.12 232.599 167.876 230.389 167.876C228.18 167.876 226.309 167.12 224.776 165.607C223.263 164.074 222.507 162.203 222.507 159.994C222.507 157.784 223.263 155.923 224.776 154.41C226.309 152.878 228.18 152.111 230.389 152.111C232.599 152.111 234.47 152.878 236.003 154.41C237.535 155.923 238.302 157.784 238.302 159.994C238.302 162.203 237.535 164.074 236.003 165.607ZM227.493 162.95C228.269 163.726 229.235 164.114 230.389 164.114C231.544 164.114 232.509 163.726 233.285 162.95C234.062 162.173 234.45 161.188 234.45 159.994C234.45 158.8 234.062 157.814 233.285 157.038C232.509 156.262 231.544 155.873 230.389 155.873C229.235 155.873 228.269 156.262 227.493 157.038C226.737 157.814 226.358 158.8 226.358 159.994C226.358 161.188 226.737 162.173 227.493 162.95Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.409 167.458H217.931L212.497 160.681V167.458H208.645V146.558H212.497V159.098L217.632 152.529H222.23L216.229 159.904L222.409 167.458Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.522 156.922C294.91 157.858 295.104 158.882 295.104 159.994C295.104 162.203 294.338 164.074 292.805 165.607C291.272 167.12 289.401 167.876 287.192 167.876C284.982 167.876 283.111 167.12 281.578 165.607C280.065 164.074 279.309 162.203 279.309 159.994C279.309 157.784 280.065 155.923 281.578 154.41C283.111 152.878 284.982 152.111 287.192 152.111C287.724 152.111 288.237 152.156 288.73 152.245C288.039 152.924 287.611 153.87 287.611 154.915C287.611 155.258 287.657 155.589 287.743 155.905C287.564 155.884 287.38 155.873 287.192 155.873C286.037 155.873 285.072 156.262 284.295 157.038C283.539 157.814 283.161 158.8 283.161 159.994C283.161 161.188 283.539 162.173 284.295 162.95C285.072 163.726 286.037 164.114 287.192 164.114C288.346 164.114 289.311 163.726 290.088 162.95C290.864 162.173 291.252 161.188 291.252 159.994C291.252 159.512 291.189 159.064 291.063 158.651C291.16 158.658 291.258 158.662 291.357 158.662C292.688 158.662 293.857 157.968 294.522 156.922Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.951 154.915C293.951 156.348 292.79 157.509 291.357 157.509C289.925 157.509 288.764 156.348 288.764 154.915C288.764 153.483 289.925 152.322 291.357 152.322C292.79 152.322 293.951 153.483 293.951 154.915Z",
    fill: "#7249F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207.308,
    y: 210.779,
    width: 44.6359,
    height: 29.7573,
    rx: 6.76301,
    fill: "url(#paint1_radial_1_818)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.626 211.076L224.666 218.852C224.666 218.852 226.65 225.657 224.666 231.489L229.626 240.238L234.585 231.489C234.585 231.489 232.601 226.629 234.585 218.852C234.585 218.852 229.626 211.076 229.626 211.076Z",
    stroke: "#C7C7B6",
    strokeWidth: 1.75838,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.308 219.209H224.666",
    stroke: "#C7C7B6",
    strokeWidth: 1.75838,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.089 219.209H251.943",
    stroke: "#C7C7B6",
    strokeWidth: 1.75838,
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.308 231.112H224.666",
    stroke: "#C7C7B6",
    strokeWidth: 1.75838,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.089 231.112H251.943",
    stroke: "#C7C7B6",
    strokeWidth: 1.75838,
    strokeLinejoin: "bevel"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -249,
    width: 383.59,
    height: 237.128,
    rx: 13.9487,
    fill: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 565.154,
    y: 7,
    width: 383.59,
    height: 237.128,
    rx: 13.9487,
    fill: "#C3C3C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_818",
    x: 141.051,
    y: 38.5128,
    width: 411.487,
    height: 265.026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97436,
    result: "effect1_foregroundBlur_1_818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_818",
    x: 148.026,
    y: 28.0513,
    width: 411.487,
    height: 265.026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97436,
    result: "effect1_foregroundBlur_1_818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_818",
    x1: 184.482,
    y1: 321.649,
    x2: 451.973,
    y2: 37.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.94 221.619) rotate(141.302) scale(30.2577 30.0282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMobile);
export default __webpack_public_path__ + "static/media/bg-mobile.f77b3fe1a1c53d1c423f7451e2a9db64.svg";
export { ForwardRef as ReactComponent };